import React, { useMemo, useCallback } from 'react';
import compact from 'lodash/compact';

import find from 'lodash/find';
import isArray from 'lodash/isArray';

import { ID } from '../../../../types';

import {
  MultiSelectExtendedDataType,
  MultiSelectChangeCallbackType
} from '../../../../helpers/MultiSelect/types';

import { useTranslate } from '../../../../common/hooks/useTranslate';

import { MultiSelect } from '../../../../helpers/MultiSelect';

import { projectsStatuses } from '../../projectsConstants';

interface ProjectsStatusesMultiSelectProps {
  value: ID[];
  autoFocus?: boolean;
  onChange: (value: ID[]) => void;
}

function ProjectsStatusesMultiSelect({
  value,
  autoFocus,
  onChange
}: ProjectsStatusesMultiSelectProps) {
  const { t } = useTranslate();
  const data = useMemo<MultiSelectExtendedDataType[]>(() => {
    return compact(
      projectsStatuses.map(({ value, i18nLabel }) => ({
        value: value,
        label: t(i18nLabel)
      }))
    );
  }, [t]);

  const multiSelectValue = useMemo<MultiSelectExtendedDataType[]>(() => {
    return isArray(value)
      ? value.map((item) => find(data, ['value', item]))
      : [];
  }, [value, data]);

  const handleChange = useCallback<MultiSelectChangeCallbackType>(
    (value: MultiSelectExtendedDataType) => {
      onChange(isArray(value) ? value.map((item) => item.value) : []);
    },
    [onChange]
  );

  return (
    <MultiSelect
      inputWrapperClassName="block"
      onChange={handleChange}
      value={multiSelectValue}
      multi={true}
      isSearchable={true}
      data={data}
      classNamePrefix="av_multi_select"
      autoFocus={autoFocus}
    />
  );
}

export default ProjectsStatusesMultiSelect;
